import React from 'react'
import { ImageComponentPropsType } from './Image.types'

const Component: React.FC<ImageComponentPropsType> = ({ imageData, aspectRatio, altText = 'Image', className }) => {
  const imageDataAspect = imageData[aspectRatio]
  const imageUrl = imageDataAspect?.url || imageData.url

  return (
    <img
      className={className}
      src={imageUrl}
      alt={altText}
      onError={(e) => {
        e.currentTarget.style.display = 'none'
      }}
    />
  )
}

export const ImageComponent = Component
